import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaUser, FaClipboardList, FaShoppingCart, FaBars, FaBoxes, FaFileInvoiceDollar, FaCubes, FaIndustry, FaFileAlt, FaUsers, FaChartBar, FaFolder, FaUserTie } from "react-icons/fa";
import { RiShoppingBag4Fill } from "react-icons/ri";
import { MdOutlineDashboard } from "react-icons/md";
import { FiMonitor } from "react-icons/fi";
import { IoIosArrowForward } from "react-icons/io";
import { TbCategory2 } from "react-icons/tb";
import { BiSolidPurchaseTag } from "react-icons/bi";
import { TbBrandAuth0 } from "react-icons/tb";
import { FaCoins } from "react-icons/fa";
import { FaUsersRectangle } from "react-icons/fa6";
import { AiOutlineFileSearch } from "react-icons/ai";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { MdOutlineInventory } from "react-icons/md";
import { BsBoxSeam } from "react-icons/bs";
import "../Pages/Sidebar.css";
import Logo from "../Assets/smartpos.png";
import axios from "axios";

const SideBar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [permissions, setPermissions] = useState({});
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [isInventoryOpen, setIsInventoryOpen] = useState(false);
  const [isPurchaseOpen, setIsPurchaseOpen] = useState(false);
  const [isSalesOpen, setIsSalesOpen] = useState(false);
  const [isManufacturingOpen, setIsManufacturingOpen] = useState(false);
  const [isDaybookOpen, setIsDaybookOpen] = useState(false);
  const [isFinanceOpen, setIsFinanceOpen] = useState(false);
  const [isFilesOpen, setIsFilesOpen] = useState(false);
  const [isEmployeeOpen, setIsEmployeeOpen] = useState(false);
  const [isItemAdjustmentOpen, setIsItemAdjustmentOpen] = useState(false);
  const [isSegmentOpen, setSegmentOpen] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const toggleReportMenu = () => {
    setIsReportOpen(!isReportOpen);
  };

  const toggleInventoryMenu = () => {
    setIsInventoryOpen(!isInventoryOpen);
  };

  const togglePurchaseMenu = () => {
    setIsPurchaseOpen(!isPurchaseOpen);
  };

  const toggleSalesMenu = () => {
    setIsSalesOpen(!isSalesOpen);
  };

  const toggleManufacturingMenu = () => {
    setIsManufacturingOpen(!isManufacturingOpen);
  };

  const toggleDaybookMenu = () => {
    setIsDaybookOpen(!isDaybookOpen);
  };

  const toggleFinanceMenu = () => {
    setIsFinanceOpen(!isFinanceOpen);
  };

  const toggleFilesMenu = () => {
    setIsFilesOpen(!isFilesOpen);
  };

  const toggleEmployeeMenu = () => {
    setIsEmployeeOpen(!isEmployeeOpen);
  };

  useEffect(() => {
    let userId = localStorage.getItem("user_id");

    if (!userId) {
      console.error("No user ID found. Please log in again.");
      return;
    }

    userId = userId.replace(/^"|"$/g, '');

    const fetchPermissions = async () => {
      try {
        console.log("Sending API request with user_id:", userId);

        const response = await axios.post(
          `${API_BASE_URL}employee_login_previllage.php`,
          { user_id: userId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
            },
          }
        );

        console.log("API Fixed Response:", response.data);

        if (response.data.head.code === 200 && response.data.body.length > 0) {
          setPermissions(response.data.body[0]);
        } else {
          // alert("Invalid Username and Password. Please check your credentials.");
        }
      } catch (error) {
        alert("API Error: Unable to fetch permissions.");
        console.error("API Error:", error);
      }
    };

    fetchPermissions();
  }, []);

  return (
    <div className="page-wrapper compact-wrapper" id="pageWrapper">
      <div className="page-body-wrapper">
        <div className={`sidebar-container1 ${isOpen ? "open" : "collapsed"}`}>
          <div className="sidebar-wrapper">
            <div className="sidebar-toggle1">
              {isOpen && (
                <NavLink to="/home" title="logo">
                  <img src={Logo} alt="logo" style={{ height: "75px", width: "210px" }} />
                </NavLink>
              )}
              &nbsp;&nbsp;

              <button onClick={toggleSidebar} className="toggle-btn1">
                {isOpen ? (
                  <i className="ri-apps-line status_toggle middle sidebar-toggle"></i>
                ) : (
                  <FaBars />
                )}
              </button>
            </div>

            <nav className="sidebar-nav1">
              <ul>
                {/* Dashboard */}
                <NavLink to="/home" className={({ isActive }) => (isActive ? "active" : "")}>
                  <li>
                    <MdOutlineDashboard />
                    {isOpen && <span>Dashboard</span>}
                  </li>
                </NavLink>

                {/* Inventory Section */}
                <li onClick={toggleInventoryMenu} className="report-menu">
                  <MdOutlineInventory />
                  {isOpen && <span>Inventory</span>}
                  <IoIosArrowForward className={`arrow-icon ${isInventoryOpen ? "open" : ""}`} />
                </li>
                {isInventoryOpen && (
                  <>
                    <ul className="report-dropdown">
                      <NavLink to="/products" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Products</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/maincategory" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Category</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/brand" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Brand</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/expired-materials" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Expired Materials</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/expiring-lots" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Expiring Lots (90 Days)</span>}
                        </li>
                      </NavLink>
                    </ul>

                    {/* New: Item Adjustment and Transfer Submenu */}
                    <li
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsItemAdjustmentOpen(!isItemAdjustmentOpen);
                      }}
                      className="report-dropdown submenu-item"
                      style={{ cursor: "pointer", paddingLeft: "20px" }}
                    >
                      {isOpen && <span style={{ fontSize: "13px", marginLeft: "10px" }}> - Item Adjustment & Transfer</span>}
                      <IoIosArrowForward className={`arrow-icon submenu-arrow ${isItemAdjustmentOpen ? "open" : ""}`} />
                    </li>
                    {isItemAdjustmentOpen && (
                      <ul className="submenu-dropdown">
                        <NavLink to="/inventory-transfer" className={({ isActive }) => (isActive ? "active" : "")}>
                          <li style={{ fontSize: "12px", paddingLeft: "45px !important" }}>
                            {isOpen && <span> - Inventory Transfer</span>}
                          </li>
                        </NavLink>
                        <NavLink to="/bin-transfer" className={({ isActive }) => (isActive ? "active" : "")}>
                          <li style={{ fontSize: "12px", paddingLeft: "45px !important" }}>
                            {isOpen && <span> - Bin Transfer</span>}
                          </li>
                        </NavLink>
                      </ul>
                    )}

                    {/* Keep remaining inventory items */}
                    <ul className="report-dropdown">
                      <NavLink to="/fifo-report" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - FIFO Item Report</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/material-status" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Material Status</span>}
                        </li>
                      </NavLink>
                    </ul>
                  </>
                )}

                {/* Purchase Section */}
                <li onClick={togglePurchaseMenu} className="report-menu">
                  <BiSolidPurchaseTag />
                  {isOpen && <span>Purchase</span>}
                  <IoIosArrowForward className={`arrow-icon ${isPurchaseOpen ? "open" : ""}`} />
                </li>
                {isPurchaseOpen && (
                  <>
                    <ul className="report-dropdown">
                      <NavLink to="/supplier" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Supplier</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/stock" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Stock Report</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/purchaselist" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Purchase List</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/po-setup" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - PO Setup</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/purchaselist" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - POS</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/po-report" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - PO Report</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/po-cancellation" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - PO Cancellation</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/po-receipt" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - PO Receipt</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/purchase-invoice" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Purchase Invoice</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/gstreportpurchase" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Purchase GST Report</span>}
                        </li>
                      </NavLink>
                    </ul>
                  </>
                )}

                {/* Sales Section */}
                <li onClick={toggleSalesMenu} className="report-menu">
                  <FaShoppingCart />
                  {isOpen && <span>Sales</span>}
                  <IoIosArrowForward className={`arrow-icon ${isSalesOpen ? "open" : ""}`} />
                </li>
                {isSalesOpen && (
                  <>
                    <ul className="report-dropdown">
                      <NavLink to="/customerlist" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Customer</span>}
                        </li>
                      </NavLink>
                      <NavLink to="/pos" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - POS</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/orderlist" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Sales Orders</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/sales-setup" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Sales Setup</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/sales-invoice" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Sales Invoice</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/sales-receipt" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Sales Receipt</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/gstreport" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Sales Report</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/gstreport" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Sales GST Report</span>}
                        </li>
                      </NavLink>
                    </ul>
                  </>
                )}

                {/* Manufacturing Section */}
                <li onClick={toggleManufacturingMenu} className="report-menu">
                  <FaIndustry />
                  {isOpen && <span>Manufacturing</span>}
                  <IoIosArrowForward className={`arrow-icon ${isManufacturingOpen ? "open" : ""}`} />
                </li>
                {isManufacturingOpen && (
                  <>
                    <ul className="report-dropdown">
                      <NavLink to="/bom" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Bill of Material</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/build-assemblies" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Build Assemblies</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/work-orders" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Build Work Orders</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/bom-report" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - BOM Report</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/work-order-report" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Work Order Report</span>}
                        </li>
                      </NavLink>
                    </ul>
                  </>
                )}

                {/* Daybook Section */}
                <li onClick={toggleDaybookMenu} className="report-menu">
                  <FaFileInvoiceDollar />
                  {isOpen && <span>Daybook</span>}
                  <IoIosArrowForward className={`arrow-icon ${isDaybookOpen ? "open" : ""}`} />
                </li>
                {isDaybookOpen && (
                  <>
                    <ul className="report-dropdown">
                      <NavLink to="/paymentdetails" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Day Book</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/paymentdetails" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Ledgers</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/journals" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Journals</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/cash-bank" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Cash & Bank</span>}
                        </li>
                      </NavLink>
                    </ul>
                  </>
                )}

                {/* Finance Section */}
                <li onClick={toggleFinanceMenu} className="report-menu">
                  <FaCoins />
                  {isOpen && <span>Finance</span>}
                  <IoIosArrowForward className={`arrow-icon ${isFinanceOpen ? "open" : ""}`} />
                </li>
                {isFinanceOpen && (
                  <>
                    <ul className="report-dropdown">
                      <NavLink to="/sales-purchase-flow" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Sales & Purchase Flow</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/currency" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Currency</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/taxes-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Taxes Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/accounts" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Accounts</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/segments" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Segments</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <li
                      onClick={(e) => {
                        e.stopPropagation();
                        setSegmentOpen(!isSegmentOpen);
                      }}
                      className="report-dropdown submenu-item"
                      style={{ cursor: "pointer", paddingLeft: "20px" }}
                    >
                      {isOpen && <span style={{ fontSize: "13px", marginLeft: "10px" }}> - Segments</span>}
                      <IoIosArrowForward className={`arrow-icon submenu-arrow ${isSegmentOpen ? "open" : ""}`} />
                    </li>
                    {isSegmentOpen && (
                      <ul className="submenu-dropdown">
                        <NavLink to="/cost-profit" className={({ isActive }) => (isActive ? "active" : "")}>
                          <li style={{ fontSize: "12px", paddingLeft: "45px !important" }}>
                            {isOpen && <span> - Cost and profit Center</span>}
                          </li>
                        </NavLink>
                        <NavLink to="/location" className={({ isActive }) => (isActive ? "active" : "")}>
                          <li style={{ fontSize: "12px", paddingLeft: "45px !important" }}>
                            {isOpen && <span> - Location</span>}
                          </li>
                        </NavLink>
                        <NavLink to="/department" className={({ isActive }) => (isActive ? "active" : "")}>
                          <li style={{ fontSize: "12px", paddingLeft: "45px !important" }}>
                            {isOpen && <span> - Department</span>}
                          </li>
                        </NavLink>
                      </ul>
                    )}
                    <ul className="report-dropdown">
                      <NavLink to="/transaction-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Transaction Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/procurement" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Procurement</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/budget" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Budget</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/cash-payments" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Cash Payments & Receipts</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/bank-payments" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Bank Payments & Receipts</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/invoice-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Invoice Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                  </>
                )}

                {/* Employee Section */}
                <li onClick={toggleEmployeeMenu} className="report-menu">
                  <FaUserTie />
                  {isOpen && <span>Employee</span>}
                  <IoIosArrowForward className={`arrow-icon ${isEmployeeOpen ? "open" : ""}`} />
                </li>
                {isEmployeeOpen && (
                  <>
                    <ul className="report-dropdown">
                      <NavLink to="/employee-sheet" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Employee Sheet</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/payroll" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Payroll</span>}
                        </li>
                      </NavLink>
                    </ul>
                  </>
                )}

                {/* Files Section */}
                <li onClick={toggleFilesMenu} className="report-menu">
                  <FaFolder />
                  {isOpen && <span>Files</span>}
                  <IoIosArrowForward className={`arrow-icon ${isFilesOpen ? "open" : ""}`} />
                </li>
                {isFilesOpen && (
                  <>
                    <ul className="report-dropdown">
                      <NavLink to="/download-files" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Download Files</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/upload-files" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Upload Files</span>}
                        </li>
                      </NavLink>
                    </ul>
                  </>
                )}

                {/* Reports Section */}
                <li onClick={toggleReportMenu} className="report-menu">
                  <FaClipboardList />
                  {isOpen && <span>Reports</span>}
                  <IoIosArrowForward className={`arrow-icon ${isReportOpen ? "open" : ""}`} />
                </li>
                {isReportOpen && (
                  <>
                    <ul className="report-dropdown">
                      <NavLink to="/inventory-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Inventory Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/sales-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Sales Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/purchase-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Purchase Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/supplierledger" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Supplier Ledger</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/order-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Order Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/customerledger" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Customer Ledger</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/bom-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - BOM Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/work-order-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Work Order Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/accounts-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Accounts Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/payroll-reports" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Payroll Reports</span>}
                        </li>
                      </NavLink>
                    </ul>
                    <ul className="report-dropdown">
                      <NavLink to="/return-report" className={({ isActive }) => (isActive ? "active" : "")}>
                        <li style={{ fontSize: "13px" }}>
                          {isOpen && <span> - Return Report</span>}
                        </li>
                      </NavLink>
                    </ul>
                  </>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;